import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { Image } from '@emotion-icons/material/Image'
import { TopToolbar } from 'src/components/insights/top-toolbar'
import { InsightPage } from 'src/components/insights/page'
import { FullScreenLoading } from 'src/components/full-screen-loading'

const PhotosContent = dynamic(() => import('src/components/insights/photos/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const PhotosPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props

  return (
    <InsightPage>
      <React.Suspense fallback={<FullScreenLoading />}>
        <TopToolbar insight={insight} />
        <PhotosContent />
      </React.Suspense>
    </InsightPage>
  )
}

export const Photos: Insight = {
  id: 'photos',
  component: PhotosPage,
  name: 'Photos',
  icon: Image,
  supportedResultTypes: ['venue', 'address', 'alphamap-location'],
  hideOnSidebar: true,
  linkTooltipFile: 'insights-link-photos',
}
